
import Menu from "@mui/material/Menu";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from "@mui/material/IconButton";
import { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";

interface FilterColumnsProps {
    anchorEl: any;
    handleClose: any;
    handleApply: any;
    handleChangeExpanded: any;
    data: any[];
    defaultData: any[];
}

function FilterColumns(props: FilterColumnsProps) {
    const [t] = useTranslation();
    const open = Boolean(props.anchorEl);
    const [columnData, setColumnData] = useState<any[]>(JSON.parse(JSON.stringify(props.data)));

    const handleSelect = (idx: number, index: number) => {
        columnData[idx].children[index].show = !columnData[idx].children[index].show
        setColumnData([...columnData]);
    }

    const handleSelectAll = (col: any, idx: number) => {
        let isShowLength = col.children.filter((item: any) => item.show).length;
        if (col.children.length === isShowLength) {
            setColumnData(columnData.map((item, index) => {
                if (idx === index) {
                    item.children.map((subItem: any) => { subItem.show = false; return subItem; });
                }
                return item;
            }));
        } else {
            setColumnData(columnData.map((item, index) => {
                if (idx === index) {
                    item.children.map((subItem: any) => { subItem.show = true; return subItem; });
                }
                return item;
            }));
        }
    }

    return <Menu
        anchorEl={props.anchorEl}
        open={open}
        onClose={props.handleClose}
        sx={{
            "& .MuiList-root": {
                py: 0,
            },
        }}
    >
        <div className="card compact dropdown-content p-0 shadow w-[380px] rounded-[4px] overflow-hidden">
            <div className="text-[16px] m-[16px] h-[19px] font-medium text-[#000000de]">{t("locationSet.columnsTitle")}</div>
            <div className="p-[8px] h-[300px] overflow-y-auto">
                {columnData.map((col: any, idx: number) => {
                    let checkedLength = col.children.filter((item: any) => item.show).length;
                    return (
                        <Accordion
                            sx={{
                                boxShadow: "none",
                                backgroundColor: "transparent",
                                margin: "0!important",
                                '&::before': {
                                    display: 'none',
                                }
                            }}
                            key={col.title}
                            expanded={col.expanded}
                        >
                            <AccordionSummary
                                expandIcon={<IconButton
                                    component="span"
                                    onClick={() => {
                                        col.expanded = !col.expanded;
                                        setColumnData([...columnData]);
                                        props.handleChangeExpanded(col.expanded, idx);
                                    }}>
                                    <div className="material-icons">keyboard_arrow_right</div>
                                </IconButton>}
                                sx={{
                                    padding: 0,
                                    margin: "0!important",
                                    minHeight: "34px!important",
                                    height: "36px!important",
                                    flexDirection: 'row-reverse',
                                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                        transform: 'rotate(90deg)',
                                    },
                                    '& .MuiAccordionSummary-content': {
                                        margin: "0!important",
                                    },
                                    '& .MuiTypography-root': {
                                        fontSize: "14px!important",
                                    },
                                    '&.Mui-expanded,': {
                                        minHeight: "34px"
                                    },
                                    '& .MuiAccordionSummary-content.Mui-expanded': {
                                        margin: "0!important",
                                    }
                                }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="success"
                                            indeterminate={checkedLength > 0 && col.children.length !== checkedLength}
                                            checked={checkedLength === col.children.length}
                                            onChange={() => handleSelectAll(col, idx)}
                                            sx={{
                                                width: "36px",
                                                height: "36px",
                                                '& .MuiSvgIcon-root': {
                                                    width: "22px!important",
                                                    height: "22px!important",
                                                }
                                            }}
                                        />}
                                    label={t("locations." + col.title)}
                                />

                            </AccordionSummary>
                            <AccordionDetails sx={{
                                padding: "0 0 0 48px",
                                width: "100%",
                                '& .MuiTypography-root': {
                                    fontSize: "14px!important",
                                },
                            }}>
                                <FormGroup>
                                    {col.children.map((item: any, index: number) => (
                                        <FormControlLabel
                                            control={<Checkbox
                                                color="success"
                                                checked={item.show}
                                                onChange={() => { handleSelect(idx, index) }}
                                                sx={{
                                                    width: "36px",
                                                    height: "36px",
                                                    '& .MuiSvgIcon-root': {
                                                        width: "22px!important",
                                                        height: "22px!important",
                                                    }
                                                }}

                                            />}
                                            label={t("locations.add." + item.title)}
                                            key={item.title}
                                        />
                                    ))}
                                </FormGroup>
                            </AccordionDetails>
                        </Accordion>)
                }
                )}
            </div>
            <div
                style={{
                    borderTop: '1px solid var(--gray-border)',
                    padding: '16px',
                    height: '64px',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Button
                    color="success"
                    disabled={JSON.stringify(columnData.map(v => v.children)) === JSON.stringify(props.defaultData.map(v => v.children))}
                    onClick={() => {
                        setColumnData(columnData.map((group, gIdx) => {
                            group.children = JSON.parse(JSON.stringify(props.defaultData[gIdx].children))
                            return group
                        }));
                    }}
                >
                    {t("buttons.reset")}
                </Button>
                <div>
                    <Button
                        color="success"
                        style={{ marginRight: '10px' }}
                        onClick={props.handleClose}>
                        {t("buttons.close")}
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        disabled={JSON.stringify(columnData.map(v => v.children)) === JSON.stringify(props.data.map(v => v.children))}
                        onClick={() => props.handleApply(columnData)}
                    >
                        {t("buttons.apply")}
                    </Button>
                </div>
            </div>
        </div>
    </Menu>;
}
export default FilterColumns;